var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","color":"primary","dense":""}},[_c('v-app-bar-title',[_c('v-btn',[_c('v-img',{attrs:{"contain":"","max-height":"35","max-width":"40","src":_vm.logoImage}})],1)],1),_c('v-spacer')],1),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }